export * from "./phlebotomist.service";



// WEBPACK FOOTER //
// ./src/app/shared/services/phlebotomist/index.ts